/**
 * Set up the global Prism object before any language components are imported.
 *
 * prism-react-renderer ships a modified Prism build that removes global/window
 * registration. The prismjs language component files (e.g. prism-clojure.js)
 * access `Prism` as a bare global. This module imports the core prismjs library
 * and assigns it to window.Prism so the language components can find it.
 *
 * This file MUST be imported before prism-languages.ts in the module graph.
 */
import Prism from 'prismjs';

(window as unknown as Record<string, unknown>).Prism = Prism;
